/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * train-with-me
 * OpenAPI spec version: 1.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  DeleteExerciseTagsParams,
  GetExerciseIdParams,
  GetExerciseIdSimilarParams,
  GetExerciseParams,
  MicrosoftAspNetCoreMvcProblemDetails,
  PatchExerciseTagsParams,
  PutExerciseIdCoverBody,
  PutExerciseIdOverlayLinksParams,
  PutExerciseIdTagsParams,
  TrainWithMeModulesExercisesDtosRequestsPatchExerciseRequest,
  TrainWithMeModulesExercisesDtosRequestsPatchExerciseTagRequest,
  TrainWithMeModulesExercisesDtosRequestsPostExerciseRequest,
  TrainWithMeModulesExercisesDtosRequestsPutExerciseOverlayLinksRequest,
  TrainWithMeModulesExercisesDtosRequestsPutExerciseTagsRequest,
  TrainWithMeModulesExercisesDtosResponsesExerciseInUseProblemResponse,
  TrainWithMeModulesExercisesDtosResponsesExerciseTagUsageResponse,
  TrainWithMeModulesExercisesDtosResponsesGetExerciseOverlayResponse,
  TrainWithMeModulesExercisesDtosResponsesGetExerciseResponse,
  TrainWithMeModulesExercisesDtosResponsesSimilarExerciseResponse,
  TrainWithMeModulesMediaDtosRequestsCreateVideoSlotRequest,
  TrainWithMeModulesMediaDtosResponsesCreateVideoSlotResponse
} from '../../model';

import { customInstance } from '../../../mutator';
import type { ErrorType , BodyType } from '../../../mutator';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export const getExercise = (
    params?: GetExerciseParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<TrainWithMeModulesExercisesDtosResponsesGetExerciseResponse[]>(
      {url: `/exercise`, method: 'GET',
        params, signal
    },
      options);
    }




export const getGetExerciseQueryKey = (params?: GetExerciseParams,) => {
    return [
    `/exercise`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetExerciseQueryOptions = <TData = Awaited<ReturnType<typeof getExercise>>, TError = ErrorType<unknown>>(params?: GetExerciseParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getExercise>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetExerciseQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getExercise>>> = ({ signal }) => getExercise(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getExercise>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetExerciseQueryResult = NonNullable<Awaited<ReturnType<typeof getExercise>>>
export type GetExerciseQueryError = ErrorType<unknown>


export function useGetExercise<TData = Awaited<ReturnType<typeof getExercise>>, TError = ErrorType<unknown>>(
 params: undefined |  GetExerciseParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getExercise>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getExercise>>,
          TError,
          Awaited<ReturnType<typeof getExercise>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetExercise<TData = Awaited<ReturnType<typeof getExercise>>, TError = ErrorType<unknown>>(
 params?: GetExerciseParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getExercise>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getExercise>>,
          TError,
          Awaited<ReturnType<typeof getExercise>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetExercise<TData = Awaited<ReturnType<typeof getExercise>>, TError = ErrorType<unknown>>(
 params?: GetExerciseParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getExercise>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetExercise<TData = Awaited<ReturnType<typeof getExercise>>, TError = ErrorType<unknown>>(
 params?: GetExerciseParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getExercise>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetExerciseQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const postExercise = (
    trainWithMeModulesExercisesDtosRequestsPostExerciseRequest?: BodyType<TrainWithMeModulesExercisesDtosRequestsPostExerciseRequest>,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<TrainWithMeModulesExercisesDtosResponsesGetExerciseResponse>(
      {url: `/exercise`, method: 'POST',
      headers: {'Content-Type': 'application/*+json', },
      data: trainWithMeModulesExercisesDtosRequestsPostExerciseRequest, signal
    },
      options);
    }




export const getPostExerciseMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postExercise>>, TError,{data?: BodyType<TrainWithMeModulesExercisesDtosRequestsPostExerciseRequest>}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof postExercise>>, TError,{data?: BodyType<TrainWithMeModulesExercisesDtosRequestsPostExerciseRequest>}, TContext> => {

const mutationKey = ['postExercise'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postExercise>>, {data?: BodyType<TrainWithMeModulesExercisesDtosRequestsPostExerciseRequest>}> = (props) => {
          const {data} = props ?? {};

          return  postExercise(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PostExerciseMutationResult = NonNullable<Awaited<ReturnType<typeof postExercise>>>
    export type PostExerciseMutationBody = BodyType<TrainWithMeModulesExercisesDtosRequestsPostExerciseRequest> | undefined
    export type PostExerciseMutationError = ErrorType<unknown>

    export const usePostExercise = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postExercise>>, TError,{data?: BodyType<TrainWithMeModulesExercisesDtosRequestsPostExerciseRequest>}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postExercise>>,
        TError,
        {data?: BodyType<TrainWithMeModulesExercisesDtosRequestsPostExerciseRequest>},
        TContext
      > => {
      return useMutation(getPostExerciseMutationOptions(options), queryClient);
    }
    export const deleteExerciseTags = (
    params: DeleteExerciseTagsParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<void>(
      {url: `/exercise/tags`, method: 'DELETE',
        params, signal
    },
      options);
    }




export const getDeleteExerciseTagsMutationOptions = <TError = ErrorType<MicrosoftAspNetCoreMvcProblemDetails>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteExerciseTags>>, TError,{params: DeleteExerciseTagsParams}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteExerciseTags>>, TError,{params: DeleteExerciseTagsParams}, TContext> => {

const mutationKey = ['deleteExerciseTags'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteExerciseTags>>, {params: DeleteExerciseTagsParams}> = (props) => {
          const {params} = props ?? {};

          return  deleteExerciseTags(params,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteExerciseTagsMutationResult = NonNullable<Awaited<ReturnType<typeof deleteExerciseTags>>>

    export type DeleteExerciseTagsMutationError = ErrorType<MicrosoftAspNetCoreMvcProblemDetails>

    export const useDeleteExerciseTags = <TError = ErrorType<MicrosoftAspNetCoreMvcProblemDetails>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteExerciseTags>>, TError,{params: DeleteExerciseTagsParams}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteExerciseTags>>,
        TError,
        {params: DeleteExerciseTagsParams},
        TContext
      > => {
      return useMutation(getDeleteExerciseTagsMutationOptions(options), queryClient);
    }
    export const getExerciseTags = (

 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<TrainWithMeModulesExercisesDtosResponsesExerciseTagUsageResponse[]>(
      {url: `/exercise/tags`, method: 'GET', signal
    },
      options);
    }




export const getGetExerciseTagsQueryKey = () => {
    return [
    `/exercise/tags`
    ] as const;
    }


export const getGetExerciseTagsQueryOptions = <TData = Awaited<ReturnType<typeof getExerciseTags>>, TError = ErrorType<MicrosoftAspNetCoreMvcProblemDetails>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getExerciseTags>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetExerciseTagsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getExerciseTags>>> = ({ signal }) => getExerciseTags(requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getExerciseTags>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetExerciseTagsQueryResult = NonNullable<Awaited<ReturnType<typeof getExerciseTags>>>
export type GetExerciseTagsQueryError = ErrorType<MicrosoftAspNetCoreMvcProblemDetails>


export function useGetExerciseTags<TData = Awaited<ReturnType<typeof getExerciseTags>>, TError = ErrorType<MicrosoftAspNetCoreMvcProblemDetails>>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getExerciseTags>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getExerciseTags>>,
          TError,
          Awaited<ReturnType<typeof getExerciseTags>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetExerciseTags<TData = Awaited<ReturnType<typeof getExerciseTags>>, TError = ErrorType<MicrosoftAspNetCoreMvcProblemDetails>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getExerciseTags>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getExerciseTags>>,
          TError,
          Awaited<ReturnType<typeof getExerciseTags>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetExerciseTags<TData = Awaited<ReturnType<typeof getExerciseTags>>, TError = ErrorType<MicrosoftAspNetCoreMvcProblemDetails>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getExerciseTags>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetExerciseTags<TData = Awaited<ReturnType<typeof getExerciseTags>>, TError = ErrorType<MicrosoftAspNetCoreMvcProblemDetails>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getExerciseTags>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetExerciseTagsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const patchExerciseTags = (
    params: PatchExerciseTagsParams,
    trainWithMeModulesExercisesDtosRequestsPatchExerciseTagRequest?: BodyType<TrainWithMeModulesExercisesDtosRequestsPatchExerciseTagRequest>,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<TrainWithMeModulesExercisesDtosResponsesExerciseTagUsageResponse>(
      {url: `/exercise/tags`, method: 'PATCH',
      headers: {'Content-Type': 'application/*+json', },
      data: trainWithMeModulesExercisesDtosRequestsPatchExerciseTagRequest,
        params, signal
    },
      options);
    }




export const getPatchExerciseTagsMutationOptions = <TError = ErrorType<MicrosoftAspNetCoreMvcProblemDetails>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchExerciseTags>>, TError,{params: PatchExerciseTagsParams;data?: BodyType<TrainWithMeModulesExercisesDtosRequestsPatchExerciseTagRequest>}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof patchExerciseTags>>, TError,{params: PatchExerciseTagsParams;data?: BodyType<TrainWithMeModulesExercisesDtosRequestsPatchExerciseTagRequest>}, TContext> => {

const mutationKey = ['patchExerciseTags'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof patchExerciseTags>>, {params: PatchExerciseTagsParams;data?: BodyType<TrainWithMeModulesExercisesDtosRequestsPatchExerciseTagRequest>}> = (props) => {
          const {params,data} = props ?? {};

          return  patchExerciseTags(params,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PatchExerciseTagsMutationResult = NonNullable<Awaited<ReturnType<typeof patchExerciseTags>>>
    export type PatchExerciseTagsMutationBody = BodyType<TrainWithMeModulesExercisesDtosRequestsPatchExerciseTagRequest> | undefined
    export type PatchExerciseTagsMutationError = ErrorType<MicrosoftAspNetCoreMvcProblemDetails>

    export const usePatchExerciseTags = <TError = ErrorType<MicrosoftAspNetCoreMvcProblemDetails>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchExerciseTags>>, TError,{params: PatchExerciseTagsParams;data?: BodyType<TrainWithMeModulesExercisesDtosRequestsPatchExerciseTagRequest>}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof patchExerciseTags>>,
        TError,
        {params: PatchExerciseTagsParams;data?: BodyType<TrainWithMeModulesExercisesDtosRequestsPatchExerciseTagRequest>},
        TContext
      > => {
      return useMutation(getPatchExerciseTagsMutationOptions(options), queryClient);
    }
    export const deleteExerciseId = (
    id: number,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<void>(
      {url: `/exercise/${id}`, method: 'DELETE', signal
    },
      options);
    }




export const getDeleteExerciseIdMutationOptions = <TError = ErrorType<MicrosoftAspNetCoreMvcProblemDetails | TrainWithMeModulesExercisesDtosResponsesExerciseInUseProblemResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteExerciseId>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteExerciseId>>, TError,{id: number}, TContext> => {

const mutationKey = ['deleteExerciseId'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteExerciseId>>, {id: number}> = (props) => {
          const {id} = props ?? {};

          return  deleteExerciseId(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteExerciseIdMutationResult = NonNullable<Awaited<ReturnType<typeof deleteExerciseId>>>

    export type DeleteExerciseIdMutationError = ErrorType<MicrosoftAspNetCoreMvcProblemDetails | TrainWithMeModulesExercisesDtosResponsesExerciseInUseProblemResponse>

    export const useDeleteExerciseId = <TError = ErrorType<MicrosoftAspNetCoreMvcProblemDetails | TrainWithMeModulesExercisesDtosResponsesExerciseInUseProblemResponse>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteExerciseId>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteExerciseId>>,
        TError,
        {id: number},
        TContext
      > => {
      return useMutation(getDeleteExerciseIdMutationOptions(options), queryClient);
    }
    export const getExerciseId = (
    id: number,
    params?: GetExerciseIdParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<TrainWithMeModulesExercisesDtosResponsesGetExerciseResponse>(
      {url: `/exercise/${id}`, method: 'GET',
        params, signal
    },
      options);
    }




export const getGetExerciseIdQueryKey = (id: number,
    params?: GetExerciseIdParams,) => {
    return [
    `/exercise/${id}`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetExerciseIdQueryOptions = <TData = Awaited<ReturnType<typeof getExerciseId>>, TError = ErrorType<unknown>>(id: number,
    params?: GetExerciseIdParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getExerciseId>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetExerciseIdQueryKey(id,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getExerciseId>>> = ({ signal }) => getExerciseId(id,params, requestOptions, signal);





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getExerciseId>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetExerciseIdQueryResult = NonNullable<Awaited<ReturnType<typeof getExerciseId>>>
export type GetExerciseIdQueryError = ErrorType<unknown>


export function useGetExerciseId<TData = Awaited<ReturnType<typeof getExerciseId>>, TError = ErrorType<unknown>>(
 id: number,
    params: undefined |  GetExerciseIdParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getExerciseId>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getExerciseId>>,
          TError,
          Awaited<ReturnType<typeof getExerciseId>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetExerciseId<TData = Awaited<ReturnType<typeof getExerciseId>>, TError = ErrorType<unknown>>(
 id: number,
    params?: GetExerciseIdParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getExerciseId>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getExerciseId>>,
          TError,
          Awaited<ReturnType<typeof getExerciseId>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetExerciseId<TData = Awaited<ReturnType<typeof getExerciseId>>, TError = ErrorType<unknown>>(
 id: number,
    params?: GetExerciseIdParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getExerciseId>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetExerciseId<TData = Awaited<ReturnType<typeof getExerciseId>>, TError = ErrorType<unknown>>(
 id: number,
    params?: GetExerciseIdParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getExerciseId>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetExerciseIdQueryOptions(id,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const patchExerciseId = (
    id: number,
    trainWithMeModulesExercisesDtosRequestsPatchExerciseRequest?: BodyType<TrainWithMeModulesExercisesDtosRequestsPatchExerciseRequest>,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<TrainWithMeModulesExercisesDtosResponsesGetExerciseResponse>(
      {url: `/exercise/${id}`, method: 'PATCH',
      headers: {'Content-Type': 'application/*+json', },
      data: trainWithMeModulesExercisesDtosRequestsPatchExerciseRequest, signal
    },
      options);
    }




export const getPatchExerciseIdMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchExerciseId>>, TError,{id: number;data?: BodyType<TrainWithMeModulesExercisesDtosRequestsPatchExerciseRequest>}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof patchExerciseId>>, TError,{id: number;data?: BodyType<TrainWithMeModulesExercisesDtosRequestsPatchExerciseRequest>}, TContext> => {

const mutationKey = ['patchExerciseId'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof patchExerciseId>>, {id: number;data?: BodyType<TrainWithMeModulesExercisesDtosRequestsPatchExerciseRequest>}> = (props) => {
          const {id,data} = props ?? {};

          return  patchExerciseId(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PatchExerciseIdMutationResult = NonNullable<Awaited<ReturnType<typeof patchExerciseId>>>
    export type PatchExerciseIdMutationBody = BodyType<TrainWithMeModulesExercisesDtosRequestsPatchExerciseRequest> | undefined
    export type PatchExerciseIdMutationError = ErrorType<unknown>

    export const usePatchExerciseId = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchExerciseId>>, TError,{id: number;data?: BodyType<TrainWithMeModulesExercisesDtosRequestsPatchExerciseRequest>}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof patchExerciseId>>,
        TError,
        {id: number;data?: BodyType<TrainWithMeModulesExercisesDtosRequestsPatchExerciseRequest>},
        TContext
      > => {
      return useMutation(getPatchExerciseIdMutationOptions(options), queryClient);
    }
    export const putExerciseIdCover = (
    id: number,
    putExerciseIdCoverBody?: BodyType<PutExerciseIdCoverBody>,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {

      const formData = new FormData();
if(putExerciseIdCoverBody?.file !== undefined) {
 formData.append(`file`, putExerciseIdCoverBody.file);
 }

      return customInstance<TrainWithMeModulesExercisesDtosResponsesGetExerciseResponse>(
      {url: `/exercise/${id}/cover`, method: 'PUT',
      headers: {'Content-Type': 'multipart/form-data', },
       data: formData, signal
    },
      options);
    }




export const getPutExerciseIdCoverMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putExerciseIdCover>>, TError,{id: number;data?: BodyType<PutExerciseIdCoverBody>}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof putExerciseIdCover>>, TError,{id: number;data?: BodyType<PutExerciseIdCoverBody>}, TContext> => {

const mutationKey = ['putExerciseIdCover'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putExerciseIdCover>>, {id: number;data?: BodyType<PutExerciseIdCoverBody>}> = (props) => {
          const {id,data} = props ?? {};

          return  putExerciseIdCover(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PutExerciseIdCoverMutationResult = NonNullable<Awaited<ReturnType<typeof putExerciseIdCover>>>
    export type PutExerciseIdCoverMutationBody = BodyType<PutExerciseIdCoverBody> | undefined
    export type PutExerciseIdCoverMutationError = ErrorType<unknown>

    export const usePutExerciseIdCover = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putExerciseIdCover>>, TError,{id: number;data?: BodyType<PutExerciseIdCoverBody>}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof putExerciseIdCover>>,
        TError,
        {id: number;data?: BodyType<PutExerciseIdCoverBody>},
        TContext
      > => {
      return useMutation(getPutExerciseIdCoverMutationOptions(options), queryClient);
    }
    export const postExerciseIdDemoVideoSlot = (
    id: number,
    trainWithMeModulesMediaDtosRequestsCreateVideoSlotRequest?: BodyType<TrainWithMeModulesMediaDtosRequestsCreateVideoSlotRequest>,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<TrainWithMeModulesMediaDtosResponsesCreateVideoSlotResponse>(
      {url: `/exercise/${id}/demo-video/slot`, method: 'POST',
      headers: {'Content-Type': 'application/*+json', },
      data: trainWithMeModulesMediaDtosRequestsCreateVideoSlotRequest, signal
    },
      options);
    }




export const getPostExerciseIdDemoVideoSlotMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postExerciseIdDemoVideoSlot>>, TError,{id: number;data?: BodyType<TrainWithMeModulesMediaDtosRequestsCreateVideoSlotRequest>}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof postExerciseIdDemoVideoSlot>>, TError,{id: number;data?: BodyType<TrainWithMeModulesMediaDtosRequestsCreateVideoSlotRequest>}, TContext> => {

const mutationKey = ['postExerciseIdDemoVideoSlot'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postExerciseIdDemoVideoSlot>>, {id: number;data?: BodyType<TrainWithMeModulesMediaDtosRequestsCreateVideoSlotRequest>}> = (props) => {
          const {id,data} = props ?? {};

          return  postExerciseIdDemoVideoSlot(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PostExerciseIdDemoVideoSlotMutationResult = NonNullable<Awaited<ReturnType<typeof postExerciseIdDemoVideoSlot>>>
    export type PostExerciseIdDemoVideoSlotMutationBody = BodyType<TrainWithMeModulesMediaDtosRequestsCreateVideoSlotRequest> | undefined
    export type PostExerciseIdDemoVideoSlotMutationError = ErrorType<unknown>

    export const usePostExerciseIdDemoVideoSlot = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postExerciseIdDemoVideoSlot>>, TError,{id: number;data?: BodyType<TrainWithMeModulesMediaDtosRequestsCreateVideoSlotRequest>}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postExerciseIdDemoVideoSlot>>,
        TError,
        {id: number;data?: BodyType<TrainWithMeModulesMediaDtosRequestsCreateVideoSlotRequest>},
        TContext
      > => {
      return useMutation(getPostExerciseIdDemoVideoSlotMutationOptions(options), queryClient);
    }
    export const deleteExerciseIdOverlay = (
    id: number,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<void>(
      {url: `/exercise/${id}/overlay`, method: 'DELETE', signal
    },
      options);
    }




export const getDeleteExerciseIdOverlayMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteExerciseIdOverlay>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteExerciseIdOverlay>>, TError,{id: number}, TContext> => {

const mutationKey = ['deleteExerciseIdOverlay'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteExerciseIdOverlay>>, {id: number}> = (props) => {
          const {id} = props ?? {};

          return  deleteExerciseIdOverlay(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteExerciseIdOverlayMutationResult = NonNullable<Awaited<ReturnType<typeof deleteExerciseIdOverlay>>>

    export type DeleteExerciseIdOverlayMutationError = ErrorType<unknown>

    export const useDeleteExerciseIdOverlay = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteExerciseIdOverlay>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteExerciseIdOverlay>>,
        TError,
        {id: number},
        TContext
      > => {
      return useMutation(getDeleteExerciseIdOverlayMutationOptions(options), queryClient);
    }
    export const getExerciseIdOverlay = (
    id: number,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<TrainWithMeModulesExercisesDtosResponsesGetExerciseOverlayResponse>(
      {url: `/exercise/${id}/overlay`, method: 'GET', signal
    },
      options);
    }




export const getGetExerciseIdOverlayQueryKey = (id: number,) => {
    return [
    `/exercise/${id}/overlay`
    ] as const;
    }


export const getGetExerciseIdOverlayQueryOptions = <TData = Awaited<ReturnType<typeof getExerciseIdOverlay>>, TError = ErrorType<unknown>>(id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getExerciseIdOverlay>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetExerciseIdOverlayQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getExerciseIdOverlay>>> = ({ signal }) => getExerciseIdOverlay(id, requestOptions, signal);





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getExerciseIdOverlay>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetExerciseIdOverlayQueryResult = NonNullable<Awaited<ReturnType<typeof getExerciseIdOverlay>>>
export type GetExerciseIdOverlayQueryError = ErrorType<unknown>


export function useGetExerciseIdOverlay<TData = Awaited<ReturnType<typeof getExerciseIdOverlay>>, TError = ErrorType<unknown>>(
 id: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getExerciseIdOverlay>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getExerciseIdOverlay>>,
          TError,
          Awaited<ReturnType<typeof getExerciseIdOverlay>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetExerciseIdOverlay<TData = Awaited<ReturnType<typeof getExerciseIdOverlay>>, TError = ErrorType<unknown>>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getExerciseIdOverlay>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getExerciseIdOverlay>>,
          TError,
          Awaited<ReturnType<typeof getExerciseIdOverlay>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetExerciseIdOverlay<TData = Awaited<ReturnType<typeof getExerciseIdOverlay>>, TError = ErrorType<unknown>>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getExerciseIdOverlay>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetExerciseIdOverlay<TData = Awaited<ReturnType<typeof getExerciseIdOverlay>>, TError = ErrorType<unknown>>(
 id: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getExerciseIdOverlay>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetExerciseIdOverlayQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const putExerciseIdOverlayLinks = (
    id: number,
    trainWithMeModulesExercisesDtosRequestsPutExerciseOverlayLinksRequest?: BodyType<TrainWithMeModulesExercisesDtosRequestsPutExerciseOverlayLinksRequest>,
    params?: PutExerciseIdOverlayLinksParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<TrainWithMeModulesExercisesDtosResponsesGetExerciseResponse>(
      {url: `/exercise/${id}/overlay/links`, method: 'PUT',
      headers: {'Content-Type': 'application/*+json', },
      data: trainWithMeModulesExercisesDtosRequestsPutExerciseOverlayLinksRequest,
        params, signal
    },
      options);
    }




export const getPutExerciseIdOverlayLinksMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putExerciseIdOverlayLinks>>, TError,{id: number;data?: BodyType<TrainWithMeModulesExercisesDtosRequestsPutExerciseOverlayLinksRequest>;params?: PutExerciseIdOverlayLinksParams}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof putExerciseIdOverlayLinks>>, TError,{id: number;data?: BodyType<TrainWithMeModulesExercisesDtosRequestsPutExerciseOverlayLinksRequest>;params?: PutExerciseIdOverlayLinksParams}, TContext> => {

const mutationKey = ['putExerciseIdOverlayLinks'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putExerciseIdOverlayLinks>>, {id: number;data?: BodyType<TrainWithMeModulesExercisesDtosRequestsPutExerciseOverlayLinksRequest>;params?: PutExerciseIdOverlayLinksParams}> = (props) => {
          const {id,data,params} = props ?? {};

          return  putExerciseIdOverlayLinks(id,data,params,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PutExerciseIdOverlayLinksMutationResult = NonNullable<Awaited<ReturnType<typeof putExerciseIdOverlayLinks>>>
    export type PutExerciseIdOverlayLinksMutationBody = BodyType<TrainWithMeModulesExercisesDtosRequestsPutExerciseOverlayLinksRequest> | undefined
    export type PutExerciseIdOverlayLinksMutationError = ErrorType<unknown>

    export const usePutExerciseIdOverlayLinks = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putExerciseIdOverlayLinks>>, TError,{id: number;data?: BodyType<TrainWithMeModulesExercisesDtosRequestsPutExerciseOverlayLinksRequest>;params?: PutExerciseIdOverlayLinksParams}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof putExerciseIdOverlayLinks>>,
        TError,
        {id: number;data?: BodyType<TrainWithMeModulesExercisesDtosRequestsPutExerciseOverlayLinksRequest>;params?: PutExerciseIdOverlayLinksParams},
        TContext
      > => {
      return useMutation(getPutExerciseIdOverlayLinksMutationOptions(options), queryClient);
    }
    export const deleteExerciseIdReviewMark = (
    id: number,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<void>(
      {url: `/exercise/${id}/review-mark`, method: 'DELETE', signal
    },
      options);
    }




export const getDeleteExerciseIdReviewMarkMutationOptions = <TError = ErrorType<MicrosoftAspNetCoreMvcProblemDetails>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteExerciseIdReviewMark>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteExerciseIdReviewMark>>, TError,{id: number}, TContext> => {

const mutationKey = ['deleteExerciseIdReviewMark'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteExerciseIdReviewMark>>, {id: number}> = (props) => {
          const {id} = props ?? {};

          return  deleteExerciseIdReviewMark(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteExerciseIdReviewMarkMutationResult = NonNullable<Awaited<ReturnType<typeof deleteExerciseIdReviewMark>>>

    export type DeleteExerciseIdReviewMarkMutationError = ErrorType<MicrosoftAspNetCoreMvcProblemDetails>

    export const useDeleteExerciseIdReviewMark = <TError = ErrorType<MicrosoftAspNetCoreMvcProblemDetails>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteExerciseIdReviewMark>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteExerciseIdReviewMark>>,
        TError,
        {id: number},
        TContext
      > => {
      return useMutation(getDeleteExerciseIdReviewMarkMutationOptions(options), queryClient);
    }
    export const getExerciseIdSimilar = (
    id: number,
    params?: GetExerciseIdSimilarParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<TrainWithMeModulesExercisesDtosResponsesSimilarExerciseResponse[]>(
      {url: `/exercise/${id}/similar`, method: 'GET',
        params, signal
    },
      options);
    }




export const getGetExerciseIdSimilarQueryKey = (id: number,
    params?: GetExerciseIdSimilarParams,) => {
    return [
    `/exercise/${id}/similar`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetExerciseIdSimilarQueryOptions = <TData = Awaited<ReturnType<typeof getExerciseIdSimilar>>, TError = ErrorType<unknown>>(id: number,
    params?: GetExerciseIdSimilarParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getExerciseIdSimilar>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetExerciseIdSimilarQueryKey(id,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getExerciseIdSimilar>>> = ({ signal }) => getExerciseIdSimilar(id,params, requestOptions, signal);





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getExerciseIdSimilar>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetExerciseIdSimilarQueryResult = NonNullable<Awaited<ReturnType<typeof getExerciseIdSimilar>>>
export type GetExerciseIdSimilarQueryError = ErrorType<unknown>


export function useGetExerciseIdSimilar<TData = Awaited<ReturnType<typeof getExerciseIdSimilar>>, TError = ErrorType<unknown>>(
 id: number,
    params: undefined |  GetExerciseIdSimilarParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getExerciseIdSimilar>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getExerciseIdSimilar>>,
          TError,
          Awaited<ReturnType<typeof getExerciseIdSimilar>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetExerciseIdSimilar<TData = Awaited<ReturnType<typeof getExerciseIdSimilar>>, TError = ErrorType<unknown>>(
 id: number,
    params?: GetExerciseIdSimilarParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getExerciseIdSimilar>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getExerciseIdSimilar>>,
          TError,
          Awaited<ReturnType<typeof getExerciseIdSimilar>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetExerciseIdSimilar<TData = Awaited<ReturnType<typeof getExerciseIdSimilar>>, TError = ErrorType<unknown>>(
 id: number,
    params?: GetExerciseIdSimilarParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getExerciseIdSimilar>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetExerciseIdSimilar<TData = Awaited<ReturnType<typeof getExerciseIdSimilar>>, TError = ErrorType<unknown>>(
 id: number,
    params?: GetExerciseIdSimilarParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getExerciseIdSimilar>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetExerciseIdSimilarQueryOptions(id,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const putExerciseIdTags = (
    id: number,
    trainWithMeModulesExercisesDtosRequestsPutExerciseTagsRequest?: BodyType<TrainWithMeModulesExercisesDtosRequestsPutExerciseTagsRequest>,
    params?: PutExerciseIdTagsParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<TrainWithMeModulesExercisesDtosResponsesGetExerciseResponse>(
      {url: `/exercise/${id}/tags`, method: 'PUT',
      headers: {'Content-Type': 'application/*+json', },
      data: trainWithMeModulesExercisesDtosRequestsPutExerciseTagsRequest,
        params, signal
    },
      options);
    }




export const getPutExerciseIdTagsMutationOptions = <TError = ErrorType<MicrosoftAspNetCoreMvcProblemDetails>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putExerciseIdTags>>, TError,{id: number;data?: BodyType<TrainWithMeModulesExercisesDtosRequestsPutExerciseTagsRequest>;params?: PutExerciseIdTagsParams}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof putExerciseIdTags>>, TError,{id: number;data?: BodyType<TrainWithMeModulesExercisesDtosRequestsPutExerciseTagsRequest>;params?: PutExerciseIdTagsParams}, TContext> => {

const mutationKey = ['putExerciseIdTags'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof putExerciseIdTags>>, {id: number;data?: BodyType<TrainWithMeModulesExercisesDtosRequestsPutExerciseTagsRequest>;params?: PutExerciseIdTagsParams}> = (props) => {
          const {id,data,params} = props ?? {};

          return  putExerciseIdTags(id,data,params,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PutExerciseIdTagsMutationResult = NonNullable<Awaited<ReturnType<typeof putExerciseIdTags>>>
    export type PutExerciseIdTagsMutationBody = BodyType<TrainWithMeModulesExercisesDtosRequestsPutExerciseTagsRequest> | undefined
    export type PutExerciseIdTagsMutationError = ErrorType<MicrosoftAspNetCoreMvcProblemDetails>

    export const usePutExerciseIdTags = <TError = ErrorType<MicrosoftAspNetCoreMvcProblemDetails>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof putExerciseIdTags>>, TError,{id: number;data?: BodyType<TrainWithMeModulesExercisesDtosRequestsPutExerciseTagsRequest>;params?: PutExerciseIdTagsParams}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof putExerciseIdTags>>,
        TError,
        {id: number;data?: BodyType<TrainWithMeModulesExercisesDtosRequestsPutExerciseTagsRequest>;params?: PutExerciseIdTagsParams},
        TContext
      > => {
      return useMutation(getPutExerciseIdTagsMutationOptions(options), queryClient);
    }
